import { render, staticRenderFns } from "./deleteHousekeepingType.vue?vue&type=template&id=676d2a68&scoped=true"
import script from "./deleteHousekeepingType.vue?vue&type=script&lang=js"
export * from "./deleteHousekeepingType.vue?vue&type=script&lang=js"
import style0 from "./deleteHousekeepingType.vue?vue&type=style&index=0&id=676d2a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d2a68",
  null
  
)

export default component.exports